import { Divider } from '@components/core-ui/Divider';
import { PageErrorState } from '@components/core-ui/PageErrorState';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { usePageContext } from '../../providers/PageProvider';
import { Organizations } from './components/Organizations';
import { Teams } from './components/Teams';
import { UserDetails } from './components/UserDetails';
import { Workspaces } from './components/Workspaces';

import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { user, domainErrors, isLoading, hasInitialError, isFetching, retryUser, fetchData } = usePageContext();

  if (hasInitialError) {
    return (
      <Wrapper>
        <PageErrorState
          message="Couldn't load user details"
          actionLabel="Retry"
          actionDisabled={isFetching}
          onAction={() => retryUser()}
        />
      </Wrapper>
    );
  }

  if (!user || isLoading) {
    return (
      <Wrapper>
        <AbsoluteSpinner overlay={true} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <UserDetails user={user} reload={fetchData} />
      <Divider />
      {domainErrors.includes('organizations') ? (
        <PageErrorState
          message="Couldn't load user organizations"
          actionLabel="Retry"
          onAction={() => retryUser('organizations')}
        />
      ) : (
        <Organizations user={user} />
      )}
      <Divider />
      {domainErrors.includes('workspaces') ? (
        <PageErrorState
          message="Couldn't load user workspaces"
          actionLabel="Retry"
          onAction={() => retryUser('workspaces')}
        />
      ) : (
        <Workspaces user={user} />
      )}
      <Divider />
      {domainErrors.includes('teams') ? (
        <PageErrorState message="Couldn't load user teams" actionLabel="Retry" onAction={() => retryUser('teams')} />
      ) : (
        <Teams user={user} />
      )}
    </Wrapper>
  );
};
